<template>
    <div>
        <ValidationObserver ref="observer">
            <b-card class="theme-form-card">
                <b-row class="theme-form-row align-items-center">
                    <b-col xs="12" md="4" class="d-flex flex-column">
                        <ValidationProvider
                            rules="required|lowercase_alphanumeric"
                            v-slot="{ errors }"
                            name="sub-domain"
                        >
                            <c-input
                                class="mt-3"
                                inputType="text"
                                inputId="slugName"
                                labelText="Enter Sub-domain *"
                                v-model="theme.slug"
                            />
                            <span class="validate-error text-danger mt-1">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col
                        xs="12"
                        md="2"
                        class="d-flex justify-content-center mt-2 mt-md-0"
                    >
                        <p
                            class="text-primary font-weight-bold mb-0 align-self-center"
                        >
                            .nipige.com
                        </p>
                    </b-col>
                    <b-col>
                        <b-form-file
                            class="theme-file-input mt-3"
                            @change="readLogo"
                            :state="Boolean(theme.logo)"
                            placeholder="Upload Company Logo..."
                            drop-placeholder="Drop file here..."
                        ></b-form-file>
                    </b-col>
                </b-row>
                <b-row class="theme-form-row">
                    <b-col md="6">
                        <color-picker
                            colorRef="primary-col"
                            colorId="primary-col"
                            label="Primary Colour (Brand Colour) *"
                            @change="(val) => (theme.primaryColor = val)"
                            ref="primary-colour"
                        ></color-picker>
                        <span v-if="showPrimaryColorError" class="text-danger"
                            >Primary color required</span
                        >
                    </b-col>
                    <b-col>
                        <color-picker
                            colorRef="primary-dark-col"
                            colorId="primary-dark-col"
                            label="Primary Dark *"
                            ref="primary-dark-colour"
                            @change="(val) => (theme.secondaryColor = val)"
                        ></color-picker>
                        <span v-if="showSecondaryColorError" class="text-danger"
                            >Secondary color required</span
                        >
                    </b-col>
                </b-row>
                <b-row class="theme-form-row">
                    <b-col>
                        <color-picker
                            colorRef="primary-light-col"
                            colorId="primary-light-col"
                            label="Primary Light"
                            ref="primary-light-colour"
                            @change="(val) => (theme.tertiaryColor = val)"
                        ></color-picker>
                    </b-col>
                    <b-col>
                        <color-picker
                            colorRef="Font-col"
                            colorId="Font-col"
                            label="Font Color"
                            ref="Font-colour"
                            @change="(val) => (theme.fontColor = val)"
                        ></color-picker>
                    </b-col>
                </b-row>
                <b-row class="theme-form-row align-items-start">
                    <b-col xs="12" md="6">
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="font"
                        >
                            <label for="font-family-select" class="font-family-label"
                                >Select Font Family *</label
                            >
                            <eb-select
                                id="font-family-select"
                                type="text"
                                class="font-select-input"
                                v-model="theme.fontFamily"
                                label="text"
                                :options="fontList"
                                placeholder="Choose a font..."
                            ></eb-select>
                            <span class="validate-error text-danger mt-1 d-block">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                </b-row>
            </b-card>

            <slot name="footer-button" :data="theme"></slot>
        </ValidationObserver>
    </div>
</template>
<script>
import {
    ValidationProvider,
    ValidationObserver,
    Validator,
} from "vee-validate";
import cInput from "@/components/FormElements/CustomInput";
import ColorPicker from "@/components/FormElements/ColorPicker.vue";
import Vue from "vue";
import ebSelect from "@/components/FormElements/Select.vue";
export default {
    name: "themeStepper",
    components: {
        cInput,
        ColorPicker,
        ebSelect,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            theme: {
                logo: "",
                slug: "",
                primaryColor: "",
                secondaryColor: "",
                tertiaryColor: "",
                fontColor: "",
                fontFamily: null,
            },
            isValidating: false,
            fontList: [
                { text: "Verdana", value: "verdana" },
                { text: "Helvetica", value: "helvetica" },
                { text: "Courier", value: "courier" },
                { text: "Arial", value: "arial" },
                { text: "Impact", value: "impact" },
                { text: "Calibri", value: "calibri" },
                { text: "Consolas", value: "consolas" },
                { text: "Georgia", value: "georgia" },
                { text: "Garamond", value: "garamond" },
                { text: "Onyx", value: "onyx" },
            ],
        };
    },
    computed: {
        showSecondaryColorError() {
            if (this.isValidating && !this.theme.secondaryColor.length)
                return true;
        },
        showPrimaryColorError() {
            if (this.isValidating && !this.theme.primaryColor.length)
                return true;
        },
    },
    methods: {
        readLogo(e) {
            const reader = new FileReader();
            reader.readAsDataURL(e.target.files[0]);
            reader.onload = () => {
                this.uploadImage(reader.result);
            };
            reader.onerror = (err) => {
                this.$toasted.error("Image not uploaded..please try again!");
            };
        },
        // upload images to the S3 bucket
        async uploadImage(image) {
            let dataobj = {
                image: image,
                key: (
                    Date.now().toString(36) +
                    Math.random().toString(36).substr(2, 5)
                ).toLowerCase(),
                isPublic: true,
                replaceExisting: true,
                basePath: "tenant",
            };
            this.showCustomToast();
            await this.$store
                .dispatch("inventory/uploadImageToStorage", dataobj)
                .then((res) => {
                    if (res) {
                        this.clearCustomToast();
                        this.theme.logo = res.data.fileUrl;
                    }
                })
                .catch((error) => {
                    this.clearCustomToast();
                    this.$toasted.error(
                        "Image not uploaded..please try again!",
                    );
                });
        },
        showCustomToast() {
            Vue.toasted.show("Uploading...", {
                type: "info",
                theme: "toasted-primary",
                singleton: true,
                duration: 1000,
            });
        },
        clearCustomToast() {
            Vue.toasted.clear();
        },
        isValid() {
            const isValid = this.$refs.observer.validate();
            return isValid;
        },
        handleValidation() {
            this.isValidating = true;
        },
    },
    mounted() {
        Validator.extend("lowercase_alphanumeric", {
            validate: (value) => /^[a-z0-9]+$/.test(value),
            message:
                "The {_field_} must be lowercase and contain only alphanumeric characters.",
        });
    },
};
</script>

<style>
.custom-file-label::after {
    background-color: var(--primary) !important;
    color: #fff !important;
    line-height: 1.2 !important;
}

.theme {
    height: 47px;
    margin-top: -3px;
    width: 53px;
}

.color-input {
    width: 350px !important;
    margin-left: 7px !important;
    height: 40px !important;
    margin-top: 1px !important;
}

.icon {
    height: 38px !important;
    margin-left: 100px !important;
    margin-top: 1px;
}

.slug-name {
    width: 100%;
}

.theme-file-input {
    width: 100%;
    max-width: 419px;
}
.font-select-input .vs__dropdown-menu {
    max-height: 200px;
    overflow-y: auto;
}
@media (max-width: 768px) {
    .slug {
        text-align: center;
    }
    .theme-file-input {
        max-width: 100%;
    }
}

.theme-form-row {
    margin-top: 1rem;
    margin-bottom: 1rem;
}

.theme-form-row:first-child {
    margin-top: 0;
}

.theme-form-card .card-body {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
}

.font-family-label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: #495057;
}

.font-select-input {
    display: block;
    width: 100%;
    max-width: 520px;
    
}

@media (max-width: 768px) {
    .font-select-input {
        max-width: 100%;
    }
}
</style>
